// extracted by mini-css-extract-plugin
module.exports = {"contentCardWrapper":"styles_contentCardWrapper__8u_4C","JobCardWrapper":"styles_JobCardWrapper__Pxxql"};